import { MarketingMessage } from "@app/core/marketing/domain/marketing-message";
import { MarketingMessageApiResponse } from "@app/core/shared/domain/api-types-filtered";

export class GetMarketingMessageMapper {
  static deserialize(data: MarketingMessageApiResponse): MarketingMessage {
    return new MarketingMessage({
      show: data.show,
      title: data.title ?? "",
      titleStyle: data.titleStyle,
      subtitle: data.subtitle ?? undefined,
      subtitleStyle: data.subtitleStyle,
      message: data.message ?? "",
      messageStyle: data.messageStyle,
      image: data.image,
      imageStyle: data.imageStyle,
      textAlign: data.textAlign || "center",
      closeButtonTop: true,
      closeButtonTopStyle: data.closeButtonTopStyle,
      fullscreen: data.fullscreen,
      links: undefined,
      buttonsConfig: (data.rightButton
        ? [
            {
              translation: data.rightButton.text,
              text: data.rightButton.text,
              action_string: "true",
              ui_color: "primary",
              redirectUrl: data.rightButton.redirectUrl || "",
              class: "col-span-12",
            },
          ]
        : []) as any,
    });
  }
}
